<template>
  <div style="padding:20px">
    <button type="submit" class="btn btn-primary" @click="showTermsAndConditions()">App's Terms And Conditions</button>

    <button type="submit" class="btn btn-primary" @click="showPrivacyPolicy()">App's Privacy Policy</button>
  </div>
</template>

<script>
var tncFile = require('../../static/pages/AppTermsAndConditions.html')
var ppFile = require('../../static/pages/AppPrivacyPolicy.html')
export default {
  data () {
    return {}
  },
  methods: {
    showTermsAndConditions: function () {
      // window.location.href = tncFile
      window.open(tncFile)
    },
    showPrivacyPolicy: function () {
      // window.location.href = ppFile
      window.open(ppFile)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/MobileAppStuff.vue